import axios from 'axios';
import API_HOST from '../api';

const mapSetApi = function() {
  const api = {};

  const getUrlStub = function(options) {
    let stub = `${API_HOST}/api`;

    if (options.hasOwnProperty('clientId')) {
      stub += `/client/${options.clientId}`;
    }

    if (options.hasOwnProperty('userId')) {
      stub += `/user/${options.userId}`;
    }

    return stub;
  };

  /*
   * Check map set name to determine validity
   */
  api.checkMapSetName = function(options, name) {
    const url = `${getUrlStub(options)}/form-validation/duplicate`;

    return axios.get(url, {
      params: {
        'has-user': !options.userId ? true : undefined,
        input: name,
        field: 'name',
        resource: 'map-set',
      },
    });
  };


  /*
   * Create Map Set
   */
  api.createMapSet = function(options, mapSet) {
    const url = `${getUrlStub(options)}/map-set`;

    return axios.post(url, mapSet);
  };


  /*
   * Delete Map Set
   */
  api.deleteMapSet = function(options) {
    const url = `${getUrlStub(options)}/map-set/${options.id}`;

    return axios.delete(url);
  };


  /*
   * Get Map Layer Metadata
   */
  api.getLayerMetadata = function() {
    const url = `${API_HOST}/data/map/layers/metadata.json`;

    return axios.get(url);
  };


  /*
   * Get Map Set
   */
  api.getMapSet = function(options) {
    const url = `${getUrlStub(options)}/map-set/${options.id}`;

    return axios.get(url);
  };


  /*
   * Get Map Sets
   */
  api.getMapSets = function(options) {
    const url = `${getUrlStub(options)}/map-set-list`;

    return axios.get(url);
  };


  /*
   * Set default Map Set
   */
  api.setDefaultMapSet = function(options) {
    const url = `${getUrlStub(options)}/map-set/${options.id}/default`;

    return axios.post(url);
  };


  /*
   * Update Map Set
   */
  api.updateMapSet = function(options, mapSet) {
    const url = `${getUrlStub(options)}/map-set/${options.id}`;

    return axios.put(url, mapSet);
  };

  return api;
};

export default mapSetApi();
